import Vue from 'vue';

import 'core-js';

import VClickOutside from 'v-click-outside';
import VModal from 'vue-js-modal';
import VueAwesomeSwiper from 'vue-awesome-swiper';

import VueHeadful from 'vue-headful';
import VueSlider from 'vue-slider-component';

import { WmsRangeSlider } from './components/range-slider/range-slider';
import { WmsRouter } from './components/router/router';

import { router } from '@/config/router';

import './plugins';

import VueTippy from 'vue-tippy';

import App from './App';

Vue.config.productionTip = false;

Vue.use(VClickOutside);
Vue.use(VModal);
Vue.use(VueAwesomeSwiper as any);

Vue.component('vue-slider', VueSlider);

Vue.component('wms-page-meta', VueHeadful);
Vue.component('wms-range-slider', WmsRangeSlider);
Vue.component('wms-router', WmsRouter);

Vue.use(VueTippy);

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
